"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vscodeExtProfile = void 0;
exports.vscodeExtProfile = {
    name: 'vscodeExtAPI',
    methods: ['executeCommand']
};
//# sourceMappingURL=profile.js.map